import { ServiceObjectTypeResponse } from '@repo/shared/types/service.types'
import axios, { AxiosInstance } from 'axios'

class ServiceService {
  private api: AxiosInstance

  constructor() {
    this.api = axios.create()

    this.api.interceptors.request.use((config) => {
      const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null
      if (token) {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    })
  }

  getServices() {
    return this.api.get<ServiceObjectTypeResponse[]>('/api/services')
  }

  getServiceById(id: string) {
    return this.api.get<ServiceObjectTypeResponse>(`/api/services/${id}`)
  }

  getServiceByCode(code: string) {
    return this.api.get<ServiceObjectTypeResponse>(`/api/services/code/${code}`)
  }

  createService(data: Partial<ServiceObjectTypeResponse>) {
    return this.api.post<ServiceObjectTypeResponse>('/api/services', data)
  }

  updateServiceById(id: string, data: Partial<ServiceObjectTypeResponse>) {
    return this.api.patch<ServiceObjectTypeResponse>(`/api/services/${id}`, data)
  }

  deleteServiceById(id: string) {
    return this.api.delete(`/api/services/${id}`)
  }

  restoreServiceById(id: string) {
    return this.api.patch<ServiceObjectTypeResponse>(`/api/services/restore/${id}`)
  }
}

export default new ServiceService()
